function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { sdkLogger } from '../../logger';
export var ShakaPlayerEngineSubtitles = /*#__PURE__*/ function() {
    "use strict";
    function ShakaPlayerEngineSubtitles(notifySubtitleCuesChanged, clearSubtitles) {
        _class_call_check(this, ShakaPlayerEngineSubtitles);
        _define_property(this, "notifySubtitleCuesChanged", void 0);
        _define_property(this, "clearSubtitles", void 0);
        _define_property(this, "subtitlesEnabled", void 0);
        _define_property(this, "subtitlesToShow", void 0);
        _define_property(this, "cachedCues", void 0);
        _define_property(this, "cueKeysSet", void 0);
        // Look for cues applicable to the position. If the endTime of a cue matches the startTime of another cue and
        // that time matches the position, omit the later cue. The later cue should have its chance on the next
        // position update.
        _define_property(this, "filterCues", void 0);
        _define_property(this, "getYpositionZone", void 0);
        this.notifySubtitleCuesChanged = notifySubtitleCuesChanged;
        this.clearSubtitles = clearSubtitles;
        this.subtitlesEnabled = false;
        this.subtitlesToShow = [];
        this.cachedCues = [];
        this.cueKeysSet = new Set();
        this.filterCues = function(cues, positionSec) {
            var applicableCues = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var cue = _step.value;
                    if (cue.startTime <= positionSec && cue.endTime >= positionSec && (cue.startTime !== positionSec || !applicableCues.some(function(applicableCue) {
                        return cue.startTime === applicableCue.endTime;
                    }))) {
                        applicableCues.push(cue);
                    }
                };
                for(var _iterator = cues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return applicableCues;
        };
        this.getYpositionZone = function(viewportAnchorY) {
            return viewportAnchorY < 30 ? 15 : 85;
        };
        sdkLogger.verbose("Creating shaka engine subtitles");
    }
    _create_class(ShakaPlayerEngineSubtitles, [
        {
            key: "configure",
            value: /** @override */ function configure(config) {}
        },
        {
            key: "append",
            value: function append(cues) {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = cues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var cue = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            var _this1, _loop = function() {
                                var containerlessCue = _step1.value;
                                // Flatten nestedCues. If a cue has nested cues, their contents should be
                                // combined and replace the payload of the parent.  However, we don't want
                                // to modify the array or objects passed in, since we don't technically own
                                // them.  So we build a new array and replace certain items in it if they
                                // need to be flattened.
                                var flattenedCue = _this1.flattenCue(containerlessCue);
                                var cueKey = _this1.getCueKey(flattenedCue);
                                /**
                 * On recent Safari versions we are getting cues with Infinity value for endTime.
                 * We are notified of the same cue multiple times and after the first one we get a cue with the correct value.
                 * So we replace the old one internally when this scenario happens.
                 */ var flatCue = flattenedCue.clone();
                                flatCue.endTime = Infinity;
                                var infKey = _this1.getCueKey(flatCue);
                                if (_this1.cueKeysSet.has(infKey)) {
                                    _this1.cachedCues = _this1.cachedCues.filter(function(elem) {
                                        return _this.getCueKey(elem) !== infKey;
                                    });
                                    _this1.cueKeysSet.delete(infKey);
                                }
                                if (_this1.cueKeysSet.has(cueKey)) {
                                    return "continue";
                                }
                                _this1.cueKeysSet.add(cueKey);
                                _this1.cachedCues.push(flattenedCue);
                            };
                            for(var _iterator1 = this.getCuesFromContainer(cue)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_this1 = this, _loop();
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getCuesFromContainer",
            value: function getCuesFromContainer(cue) {
                if (cue.isContainer) {
                    var res = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = cue.nestedCues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var innerCue = _step.value;
                            if (innerCue.isContainer) {
                                var _res;
                                (_res = res).push.apply(_res, _to_consumable_array(this.getCuesFromContainer(innerCue)));
                            } else {
                                res.push(innerCue);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return res;
                } else {
                    return [
                        cue
                    ];
                }
            }
        },
        {
            key: "remove",
            value: function remove(start, end) {
                this.removeCuesMatching(function(c) {
                    return c.startTime >= start && c.endTime <= end;
                });
                sdkLogger.verbose("Removed subtitles from ".concat(start, " to ").concat(end, ". Subtitles remaining on cache ").concat(this.cachedCues.length));
                return true;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                sdkLogger.verbose("Destroying shaka engine subtitles");
                if (this.subtitlesEnabled) {
                    this.clearSubtitles();
                }
                this.cueKeysSet.clear();
                this.cueKeysSet = new Set();
                this.cachedCues = [];
                this.subtitlesToShow = [];
            }
        },
        {
            key: "isTextVisible",
            value: function isTextVisible() {
                return this.subtitlesEnabled;
            }
        },
        {
            key: "setTextVisibility",
            value: function setTextVisibility(on) {
                sdkLogger.verbose("Setting text visibility to ".concat(on, " on shaka engine subtitles"));
                this.subtitlesEnabled = on;
                if (!on) {
                    this.clearSubtitles();
                }
            }
        },
        {
            key: "handlePositionChanged",
            value: function handlePositionChanged(positionSec) {
                var _this = this;
                if (this.subtitlesEnabled) {
                    var subtitlesToShow = this.filterCues(this.cachedCues, positionSec);
                    if (this.subtitlesToShow.length !== subtitlesToShow.length || subtitlesToShow.some(function(cue, idx) {
                        return cue !== _this.subtitlesToShow[idx];
                    })) {
                        this.subtitlesToShow = subtitlesToShow;
                        this.notifySubtitleCuesChanged(this.normalizeSubtitleTextData(subtitlesToShow));
                    }
                }
            }
        },
        {
            key: "notifySeekStarted",
            value: function notifySeekStarted() {
                /**
         * Due to Safari in newer versions notifying cues with Infinity endTime
         * We need to remove them when a seek happens or else they will always show in the UI
         */ this.removeCuesMatching(function(c) {
                    return c.endTime === Infinity;
                });
                this.clearSubtitles();
            }
        },
        {
            key: "removeCuesMatching",
            value: function removeCuesMatching(matcher) {
                var _this = this;
                var removedCues = [];
                this.cachedCues = this.cachedCues.filter(function(c) {
                    if (matcher(c)) {
                        removedCues.push(c);
                        return false;
                    }
                    return true;
                });
                removedCues.forEach(function(c) {
                    return _this.cueKeysSet.delete(_this.getCueKey(c));
                });
            }
        },
        {
            key: "getCueKey",
            value: function getCueKey(cue) {
                return "".concat(cue.startTime, ":").concat(cue.endTime, ":").concat(cue.payload);
            }
        },
        {
            key: "flattenCue",
            value: /**
     * Recursively flattens a single cue.
     * @param cue text cue from shaka
     * @returns flattened cue
     */ function flattenCue(cue) {
                var flatCue = cue.clone();
                this.flattenStyles(flatCue);
                flatCue.nestedCues = [];
                flatCue.payload = this.flattenPayload(cue);
                return flatCue;
            }
        },
        {
            key: "flattenStyles",
            value: function flattenStyles(cue) {
                if (!cue.nestedCues.length) {
                    return;
                }
                // keys that by default are zeros or empty strings
                var keysToCopy = [
                    'backgroundColor',
                    'color',
                    'fontFamily',
                    'textShadow'
                ];
                // keys which always have something set in shaka
                var keysToCopyWithDefaultValues = [
                    'fontSize',
                    'fontWeight',
                    'fontStyle',
                    'wrapLine'
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysToCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // if parent has something defined, don't override it
                        if (cue[key]) {
                            continue;
                        }
                        this.flattenKey(cue, key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = keysToCopyWithDefaultValues[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var key1 = _step1.value;
                        this.flattenKey(cue, key1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "flattenKey",
            value: function flattenKey(cue, key) {
                var _this = this;
                var first = cue.nestedCues.find(function(inner) {
                    return !_this.isLineBreak(inner);
                });
                if (first && cue.nestedCues.filter(function(inner) {
                    return !_this.isLineBreak(inner);
                }).every(function(inner) {
                    return first[key] === inner[key];
                })) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- dirty workaround, otherwise typescript claims Type 'any' is not assignable to type 'never'
                    cue[key] = first[key];
                }
            }
        },
        {
            key: "flattenPayload",
            value: function flattenPayload(cue) {
                var _this = this;
                if (cue.nestedCues.length) {
                    // Recursive case. Go deeper with flattening.
                    return cue.nestedCues.reduce(function(acc, inner) {
                        return acc + _this.flattenPayload(inner);
                    }, '');
                } else if (this.isLineBreak(cue)) {
                    // This is a vertical lineBreak, so insert a newline.
                    return '\n';
                } else {
                    // This is a real cue.
                    var styleTags = [];
                    if (cue.fontWeight >= shaka.text.Cue.fontWeight.BOLD) {
                        styleTags.push('b');
                    }
                    if (cue.fontStyle === shaka.text.Cue.fontStyle.ITALIC) {
                        styleTags.push('i');
                    }
                    if (cue.textDecoration.includes(shaka.text.Cue.textDecoration.UNDERLINE)) {
                        styleTags.push('u');
                    }
                    return styleTags.reduceRight(function(acc, tag) {
                        return "<".concat(tag, ">").concat(acc, "</").concat(tag, ">");
                    }, cue.payload);
                }
            }
        },
        {
            key: "normalizeSubtitleTextData",
            value: function normalizeSubtitleTextData(cueEvents) {
                var CEA_MAX_ROWS = 16;
                // Equivalent to shaka.cea.Cea708Window.MAX_ROWS for differentiating caption types.
                var cues = [];
                var previousCueEvent;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = cueEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var cueEvent = _step.value;
                        var _cueEvent_textDecoration;
                        var payload = cueEvent.payload;
                        var style = {
                            backgroundColor: cueEvent.backgroundColor,
                            color: cueEvent.color,
                            fontFamily: cueEvent.fontFamily,
                            fontSize: cueEvent.fontSize,
                            size: cueEvent.size,
                            textAlign: cueEvent.textAlign,
                            xPosition: cueEvent.position !== null && +cueEvent.position || 'auto',
                            yPosition: cueEvent.lineInterpretation === 1 && cueEvent.line !== null && +cueEvent.line || 'auto',
                            textDecoration: (_cueEvent_textDecoration = cueEvent.textDecoration) === null || _cueEvent_textDecoration === void 0 ? void 0 : _cueEvent_textDecoration.join(' '),
                            fontWeight: cueEvent.fontWeight,
                            fontStyle: cueEvent.fontStyle,
                            textShadow: cueEvent.textShadow
                        };
                        if (style.yPosition === 'auto' && cueEvent.region.id && cueEvent.region.height < CEA_MAX_ROWS) {
                            // set explicitly yPosition if captions not using TTML.
                            style.yPosition = this.getYpositionZone(cueEvent.region.viewportAnchorY);
                        }
                        if (cues.length && previousCueEvent && previousCueEvent.startTime === cueEvent.startTime && previousCueEvent.endTime === cueEvent.endTime && this.getYpositionZone(previousCueEvent.region.viewportAnchorY) === style.yPosition) {
                            // combine consecutive cues that have matching start/end times so they will not overlap each other
                            if (previousCueEvent.region.viewportAnchorY < cueEvent.region.viewportAnchorY) {
                                payload = "".concat(cues[cues.length - 1].text, "\n").concat(cueEvent.payload);
                            } else {
                                payload = "".concat(cueEvent.payload, "\n").concat(cues[cues.length - 1].text);
                            }
                            cues.pop();
                        } else {
                            previousCueEvent = cueEvent;
                        }
                        cues.push({
                            style: style,
                            text: payload,
                            html: payload
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return cues;
            }
        },
        {
            key: "isLineBreak",
            value: function isLineBreak(cue) {
                return cue.lineBreak || cue.spacer;
            }
        }
    ], [
        {
            key: "convertFromTextTrackCueToShakaCue",
            value: // For Safari we have this workaround to use the cuechange event API to expose the cues
            // which gives us a VTTCue.
            function convertFromTextTrackCueToShakaCue(textTrackVttCue) {
                var shakaTextCue = new shaka.text.Cue(textTrackVttCue.startTime, textTrackVttCue.endTime, textTrackVttCue.text);
                shakaTextCue.line = typeof textTrackVttCue.line === 'number' ? textTrackVttCue.line : null;
                if (textTrackVttCue.region) {
                    shakaTextCue.region = _object_spread_props(_object_spread({}, shakaTextCue.region, textTrackVttCue.region), {
                        height: textTrackVttCue.region.lines,
                        heightUnits: shaka.text.CueRegion.units.LINES,
                        scroll: textTrackVttCue.region.scroll
                    });
                }
                shakaTextCue.lineAlign = textTrackVttCue.lineAlign;
                shakaTextCue.textAlign = textTrackVttCue.align;
                shakaTextCue.positionAlign = textTrackVttCue.positionAlign;
                shakaTextCue.size = textTrackVttCue.size;
                shakaTextCue.position = typeof textTrackVttCue.position === 'number' ? textTrackVttCue.position : null;
                // writing mode is HORIZONTAL_TOP_TO_BOTTOM by default
                if (textTrackVttCue.vertical === 'lr') {
                    shakaTextCue.writingMode = shaka.text.Cue.writingMode.VERTICAL_LEFT_TO_RIGHT;
                } else if (textTrackVttCue.vertical === 'rl') {
                    shakaTextCue.writingMode = shaka.text.Cue.writingMode.VERTICAL_RIGHT_TO_LEFT;
                }
                // lineInterpretation is 0 (LINE_NUMBER) by default
                if (textTrackVttCue.snapToLines === false) {
                    shakaTextCue.lineInterpretation = shaka.text.Cue.lineInterpretation.PERCENTAGE;
                }
                return shakaTextCue;
            }
        }
    ]);
    return ShakaPlayerEngineSubtitles;
}();

//# sourceMappingURL=shaka-player-engine-subtitles.js.map